import AddChackInstrumentDetail from "../components/configuration/chack/AddChackInstrumentDetail";

const AddChackInstrumentDetailPage = () =>{
    return(
        <>
         <AddChackInstrumentDetail/>
        </>
    )
}

export default AddChackInstrumentDetailPage;